import type { SiteContent } from "./types.js";

const content: SiteContent = {
  meta: {
    title: "Kuori — el evento entero, por quienes estuvieron allí",
    description:
      "El invitado entra por el código QR, fotografía desde el navegador y las fotos van al álbum del evento y a la pantalla en vivo. Sin instalar ninguna app.",
    whatsapp: "¡Hola! Vengo del sitio de Kuori y quiero saber más.",
    photoAlt: {
      hero: "Invitados con los brazos en alto en la pista, bajo luz cálida de fiesta",
      foot: "Fuegos artificiales al cierre de la fiesta, vistos detrás de los invitados",
      brand: "Tarjeta de mesa con código QR sobre la mesa puesta, a la luz de las velas",
    },
    shotAlt: {
      guest: "La cámara del evento abierta en el teléfono del invitado",
      organizer: "El panel del organizador con el resumen de un evento",
      telao: "La pantalla completa con las fotos reveladas del evento",
    },
  },
  nav: {
    language: "Idioma",
    sections: "Secciones",
    menu: "Abrir el menú",
    close: "Cerrar el menú",
    como: "Cómo funciona",
    produto: "Producto",
    precos: "Precios",
    faq: "Preguntas",
    cta: "Hablar por WhatsApp",
    short: "Hablar",
  },
  hero: {
    kicker: "Fotos del evento, tomadas por los invitados",
    title: ["El evento entero,", "por quienes ", "estuvieron allí"],
    sub: "El invitado entra por el código QR, fotografía desde el navegador y las fotos van al álbum del evento y a la pantalla en vivo. Sin instalar ninguna app.",
    cta: "Hablar por WhatsApp",
    alt: "Ver cómo funciona",
  },
  facts: [
    ["Sin app", "El invitado abre la cámara en el navegador, directo desde el QR."],
    ["En vivo", "Las fotos llegan al álbum y a la pantalla mientras ocurre el evento."],
    ["Bajo control", "Moderás, ocultás y decidís cuándo se revelan las fotos."],
  ],
  how: {
    label: "Cómo funciona",
    title: "Tres pasos, ninguna descarga.",
    steps: [
      [
        "01",
        "Creá el evento",
        "Nombre, fecha, cuántos invitados y cuándo aparecen las fotos. Un minuto, y el QR sale listo para imprimir.",
      ],
      [
        "02",
        "Repartí el QR",
        "En la invitación, en la tarjeta de mesa, en la pantalla. Quien apunta la cámara entra al instante, por el navegador.",
      ],
      [
        "03",
        "Recibí el álbum",
        "Las fotos llegan separadas por hora, moderadas y descargables en calidad original.",
      ],
    ],
  },
  guest: {
    label: "El invitado",
    title: "Una cámara que cabe en segundos.",
    body: "Abre, fotografía, vuelve al evento. La cámara tiene cuota por persona, funciona dentro de WhatsApp e Instagram, y no pide registro ni instalación.",
    bullets: [
      "Entra por QR o enlace",
      "Cuota de fotos por persona",
      "Álbum del evento en el mismo lugar",
      "Funciona en 4G, sin app",
    ],
  },
  organizer: {
    label: "El organizador",
    title: "Un panel para todos tus eventos.",
    body: "Creá, seguí y moderá desde donde estés. Cada evento tiene su invitación, su álbum por hora, su cola de moderación y su pantalla.",
    bullets: [
      "Panel multievento",
      "Invitación con QR y enlace corto",
      "Moderación y baneo",
      "Revelado en vivo o al final",
    ],
  },
  panel: {
    label:
      "Ilustración del panel del organizador: la lista de eventos con una boda en vivo, dos eventos agendados y un cumpleaños terminado",
    title: "Eventos",
    newEvent: "Nuevo evento",
    rail: ["Eventos", "Preferencias"],
    groups: { live: "En vivo ahora", upcoming: "Próximos", ended: "Terminados" },
    status: { live: "En vivo", scheduled: "Agendado", ended: "Terminado" },
    remaining: "41h",
    events: {
      wedding: {
        name: "Boda de Ana y Rafael",
        meta: "sáb, 19 sept · 19:00 · 183 invitados · 1.247 fotos y videos",
        short: "1.247 fotos y videos",
      },
      graduation: {
        name: "Graduación Medicina 2026",
        meta: "vie, 2 oct · 21:00 · Invitados 0/250",
        short: "vie, 2 oct · 21:00",
      },
      company: {
        name: "Fiesta de fin de año Vertex",
        meta: "vie, 11 dic · 20:00 · Invitados 0/100",
        short: "vie, 11 dic · 20:00",
      },
      birthday: {
        name: "Cumpleaños 30 · Beatriz",
        meta: "sáb, 22 ago · 38 invitados · 289 fotos y videos",
        short: "289 fotos y videos",
      },
    },
  },
  telao: {
    label: "Pantalla",
    title: "El evento viéndose a sí mismo.",
    body: "Una página a pantalla completa en el proyector o la TV. Las fotos entran apenas se revelan, con el nombre de quien las tomó, legibles a metros.",
  },
  brand: {
    label: "Marca blanca",
    title: "Tu nombre adelante, el nuestro fuera del camino.",
    body: "Los profesionales de eventos entregan Kuori con su propio nombre, logo y color. La interfaz es neutra a propósito: el color de la pantalla viene de las fotos del evento, no de nuestra marca.",
  },
  pricing: {
    label: "Precios",
    title: "Pago por evento. Sin suscripción.",
    sub: "Elegís el tramo según los invitados esperados. Podés subir después pagando solo la diferencia, sin crear otro evento.",
    tracks: [
      ["pessoal", "Personal"],
      ["empresarial", "Empresarial"],
    ],
    trackNote: {
      pessoal: "Parejas, cumpleaños, graduaciones y viajes. Autoservicio hasta 200 invitados.",
      empresarial:
        "Organizadores, catering, agencias y empresas. Autoservicio hasta 750 invitados, con factura.",
    },
    q1: "¿Qué tipo de evento?",
    q2: "¿Cuántos invitados?",
    upTo: "Hasta {n} invitados",
    over: "Más de {n} invitados",
    perPerson: " por persona",
    freeNote: "Para probarlo con un grupo chico, sin tarjeta.",
    paidNote:
      "Pago único para este evento. Podés subir de tramo después pagando solo la diferencia.",
    contactNote:
      "En esta vía, los eventos de este tamaño pasan por nuestro equipo. Escribinos y armamos el presupuesto.",
    contact: "Hablá con nosotros",
    free: "Gratis",
    includesLabel: "Qué incluye",
    includes: {
      free: ["Cámara del evento con cuota por persona", "Álbum revelado", "Retención de 30 días"],
      paid: [
        "Video corto de hasta 30 s en 1080p",
        "Fotos en calidad original",
        "Tarjeta de mesa personalizada",
        "Pantalla en vivo",
        "12 meses de acceso, más 12 solo para exportar",
      ],
    },
    everyone:
      "Reacciones, comentarios, moderación, filtro por persona y “mis fotos” valen para todo evento, pago o no.",
    disclaimer:
      "Valores en reales, a confirmar. Por encima de los tramos de autoservicio, armamos el presupuesto con vos.",
  },
  faq: {
    label: "Preguntas",
    title: "Lo que preguntan antes de cerrar.",
    items: [
      [
        "¿El invitado tiene que instalar algo?",
        "No. Apunta la cámara al QR, se abre el navegador y la cámara del evento ya está ahí. Funciona dentro de WhatsApp e Instagram.",
      ],
      [
        "¿Puedo revisar las fotos antes de que aparezcan?",
        "Sí. El revelado puede ser en vivo o solo al final, y podés ocultar, borrar o banear a un autor en cualquier momento.",
      ],
      [
        "¿Y si el evento supera el tramo que compré?",
        "Subís de tramo y pagás solo la diferencia. Mismo evento, mismo QR, mismo álbum.",
      ],
      [
        "¿Puedo entregarlo con mi marca?",
        "Sí. Nombre, logo y color de acento son tuyos, en la invitación, el álbum y la pantalla.",
      ],
      [
        "¿Cuánto tiempo quedan disponibles las fotos?",
        "En cualquier tramo pago, 12 meses de acceso y 12 meses más para exportar. En el plan gratis, 30 días.",
      ],
      [
        "¿Funciona con mala conexión?",
        "La cámara está hecha para 4G. Las fotos entran en una cola y suben cuando la conexión lo permite, sin trabar al invitado.",
      ],
    ],
  },
  foot: {
    cta: "Hablar por WhatsApp",
    note: "Respondemos el mismo día hábil.",
    rights: "2026 Kuori",
  },
};

export default content;
